import i18next from 'i18next';
// import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import moment from 'moment';

const {
  TRANSLATION_BACKEND,
  TRANSLATION_BACKEND_PROJECTID,
  TRANSLATION_BACKEND_APIKEY,
} = process.env;

const isBrowser = typeof window !== 'undefined';
// eslint-disable-next-line
const Backend = isBrowser ? require('i18next-service-backend').default : null;
const i18n = isBrowser ? i18next.use(Backend) : i18next;

i18n
  // .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'en',

    // have a common namespace used around the full app
    preload: ['en'],
    ns: ['default'],
    defaultNS: 'default',
    ...TRANSLATION_BACKEND_APIKEY && {
      saveMissing: true,
    },

    backend: {
      service: TRANSLATION_BACKEND,
      projectId: TRANSLATION_BACKEND_PROJECTID,
      ...TRANSLATION_BACKEND_APIKEY && {
        apiKey: TRANSLATION_BACKEND_APIKEY,
      },
      referenceLng: 'en',
      version: 'latest',
    },

    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
      format: (value, format, lng) => {
        const ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:?\d\d)|Z)?$/i;
        // Helper to calculate the hours or minutes since posted.
        const diff = ({ timing = false } = {}) => function(now) { // eslint-disable-line
          const years = now.diff(this, 'years');
          if (years > 0 || years < 0) {
            return `[${i18n.t('years', { count: years })}]`;
          }
          const months = now.diff(this, 'months');
          if (months > 0 || months < 0) {
            return `[${i18n.t('months', { count: Math.abs(months) })}]`;
          }
          const weeks = now.diff(this, 'hours') / (7 * 24);
          if (weeks > 6 / 7 || weeks < -6 / 7) { // round up 6 days to 1 week.
            return `[${i18n.t('weeks', { count: Math.abs(Math.round(weeks)) })}]`;
          }
          const days = now.diff(this, 'hours') / 24;
          if (days > 22 / 24 || days < -22 / 24) { // round up 22 hours to 1 day.
            return `[${i18n.t('days', { count: Math.abs(Math.round(days)) })}]`;
          }
          const hrs = now.diff(this, 'minutes') / 60;
          if (hrs > 40 / 60 || hrs < -40 / 60) { // round up 40+ minutes to an hour.
            return `[${i18n.t('hours', { count: Math.abs(Math.round(hrs)) })}]`;
          }
          const mins = now.diff(this, 'minutes');
          if (mins > 0 || mins < 0) {
            return `[${i18n.t('minutes', { count: Math.abs(mins) })}]`;
          }
          const sec = now.diff(this, 'seconds');
          if (timing || sec > 10 || sec < -10) {
            return `[${i18n.t('seconds', { count: Math.abs(sec) })}]`;
          }
          if (!timing) {
            return `[${i18n.t('calendar_present_date')}]`;
          }
          return `[${i18n.t('seconds', { count: 0 })}]`;
        };
        if (ISO_8601_FULL.test(value) || value instanceof Date) {
          moment.locale(lng);
          switch (format) {
            case 'calendar': {
              return moment(value).calendar(moment(), {
                sameDay: diff(),
                nextDay: diff(),
                nextWeek: diff(),
                lastDay: diff(),
                lastWeek: diff(),
                sameElse: diff(),
              });
            }

            case 'calendar_ago': {
              const out = moment(value).calendar(moment(), {
                sameDay: diff(),
                nextDay: diff(),
                nextWeek: diff(),
                lastDay: diff(),
                lastWeek: diff(),
                sameElse: diff(),
              });
              if (moment(value).diff(moment(), 'seconds') < 10) {
                return `${out} ${i18n.t('ago')}`;
              }
              return out;
            }

            case 'timing': {
              return moment(value).calendar(moment(), {
                sameDay: diff({ timing: true }),
                nextDay: diff({ timing: true }),
                nextWeek: diff({ timing: true }),
                lastDay: diff({ timing: true }),
                lastWeek: diff({ timing: true }),
                sameElse: diff({ timing: true }),
              });
            }

            default: {
              return moment(value).format(format);
            }
          }
        } else {
          switch (format) {
            case 'number':
              return (value || 0).toLocaleString();

            default:
              return value;
          }
        }
      },
    },

    react: {
      wait: false,
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/data/i18n.js